import { useEffect, useState } from "react";

const useRoomManagement = (formCount, forms, setValue) => {
    const [roomsCount, setRoomCount] = useState([{ adult: 1, child: 0, childAges: [] }]);
    const [infant, setInfant] = useState([]);
    const [totalPersons, setTotalPersons] = useState([]);
    const [extendPrice, setExtendPrice] = useState(0);

    const handleRoomCountChange = (rooms, all, formIndex) => {
        const halfPayRule = formCount[formIndex]?.halfPayRule;

        // Update room count
        setRoomCount(values => {
            const newArray = [...values];
            newArray[formIndex] = rooms?.[0];
            return newArray;
        });

        // Update infant ages
        setInfant(values => {
            const newArray = [...values];
            newArray[formIndex] = rooms?.[0].childAges?.filter(age => age.id < halfPayRule?.conditions?.max_infant_age);
            return newArray;
        });

        // Update total persons
        setTotalPersons(values => {
            const newArray = [...values];
            newArray[formIndex] = all;
            return newArray;
        });

        // Set values for passengers
        setValue(`passengers.${formIndex}.roomsCount`, rooms?.[0]);
        setValue(`passengers.${formIndex}.children`, rooms?.[0]?.child > 0 ? rooms[0]?.childAges?.map(age => age.id) : []);
    };

    useEffect(() => {
        if (forms?.length) {
            forms.forEach((field, index) => {
                const roomCapacity = formCount[index]?.capacity;
                const totalPassengers = totalPersons?.[index];
                const extraPassengers = totalPassengers - roomCapacity;
                const childCount = roomsCount?.[index]?.child;
                const childAges = roomsCount?.[index]?.childAges;

                if (extraPassengers > 0) {
                    const roomPrices = formCount[index]?.prices;
                    const halfPayRule = formCount[index]?.halfPayRule;
                    const infantCount = infant?.[index]?.length;

                    const price = calculateExtendPrice(extraPassengers, childCount, childAges, roomPrices, halfPayRule, infantCount);
                    setValue(`passengers.${index}.extend_price`, price);
                    setExtendPrice(price);
                } else {
                    setValue(`passengers.${index}.extend_price`, 0);
                }
            });
        }
    }, [forms, totalPersons, roomsCount, infant]);

    const calculateExtendPrice = (extraPassengers, childCount, childAges, roomPrices, halfPayRule, infantCount) => {
        if (childCount - infantCount > 0 && roomPrices.accept_child && halfPayRule) {
            const eligibleChildren = childAges.filter(
                age => age.id >= halfPayRule.conditions.max_infant_age && age.id < halfPayRule.conditions.max_child_age,
            );

            if (eligibleChildren.length) {
                return (extraPassengers - infantCount - 1) * roomPrices.total_extend_price + roomPrices.total_child_price;
            } else {
                return (extraPassengers - infantCount) * roomPrices.total_extend_price;
            }
        } else {
            return (extraPassengers - infantCount) * roomPrices.total_extend_price;
        }
    };

    return {
        handleRoomCountChange,
        extendPrice,
        infant,
        totalPersons,
        extendPrice,
    };
};

export default useRoomManagement;
